/**
 * @license
 * jabm.dev
 * Copyright (C) 2024–present JustABoredMaker.

 * This file is part of jabm.dev.

 * jabm.dev is free software: you can redistribute it and/or modify it under the
 * terms of the GNU General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later
 * version.

 * jabm.dev is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License along with
 * jabm.dev. If not, see <https://www.gnu.org/licenses/>.
 *
 * Home: https://gitlab.com/JustABoredMaker/jabm.dev
 */

const errorDiv: HTMLDivElement = document.createElement("div");
errorDiv.classList.add("error");
errorDiv.setAttribute("popover", "auto");

const errorSpan: HTMLSpanElement = document.createElement("span");
errorSpan.classList.add("error-text");

const errorSpanHint: HTMLSpanElement = document.createElement("span");
errorSpanHint.classList.add("hint");

let textNode1: Text = document.createTextNode("Click anywhere outside this box or press ");
let escKey: HTMLElement = document.createElement("kbd");
escKey.textContent = "Esc";
let textNode2: Text = document.createTextNode(" to close this popup.");

errorSpanHint.appendChild(textNode1);
errorSpanHint.appendChild(escKey);
errorSpanHint.appendChild(textNode2);

document.body.append(errorDiv);
errorDiv.append(errorSpan);
errorDiv.append(errorSpanHint);

/**
 * Shows error message in div.error popover
 *
 * @class JError
 * @extends {Error}
 */
class JError extends Error {
	/**
	 * Creates an instance of JError.
	 *
	 * @constructor
	 * @param {string} message - Error message
	 * @param {(ErrorOptions | undefined)} options - Error options
	 */
	constructor(message: string, options?: ErrorOptions) {
		super(message, options);
		errorDiv.togglePopover();
		errorSpan.innerText = message;
	}
}
